import { Icon } from '@iconify/react';
import {
  Box,
  Button,
  Card,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  styled,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectItemAction } from '../../../redux/slices/selectCreateComponent';
import MenuCardButton from './MenuCardButton';

const CuztomCard = styled(Card)(() => ({
  marginTop: '15px',
  padding: '20px 15px',
  display: 'flex',
  alignItems: 'center',
  gap: '20px'
}));

const BoxData = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: '90px 1fr'
}));

function CardItem({ selectCreateId = 'comp1', dataItem, showedProps = [], functionList = [] }) {
  // const [openDialog, setOpenDialog] = useState(false);
  const [item, setItem] = useState({});
  const [formatItem, setFormatItem] = useState([]);
  const { functions, itemsSelected } = useSelector((state) => state.selectCreate);
  const dispatch = useDispatch();

  const findedItem = itemsSelected.find((item) => item.selectCreateId === selectCreateId);
  const findedFunction = functions.find((fun) => fun.selectCreateId === selectCreateId);

  const selectHandler = () => {
    dispatch(selectItemAction(item));
    findedFunction.itemsListHandler(false);
  };

  useEffect(() => {
    setItem({ ...dataItem, selectCreateId });
  }, [selectCreateId, dataItem]);

  useEffect(() => {
    const myArr = [];
    if (showedProps.length) {
      showedProps.map((prop) => {
        const newObj = {};
        const { key, label } = prop;
        newObj.value = dataItem[key];
        newObj.label = label;
        newObj.key = key;

        myArr.push(newObj);
        return false;
      });
    }
    setFormatItem(myArr);
  }, [dataItem, showedProps]);

  return (
    <CuztomCard>
      <Box sx={{ flexGrow: 1 }}>
        {formatItem?.map((it, i) => (
          <BoxData key={i}>
            <Typography variant="subtitle2">{it.label}:</Typography>
            <Typography variant="body2">{it.value}</Typography>
          </BoxData>
        ))}
      </Box>
      <Box sx={{ display: 'flex', gap: '5px', justifyContent: 'center', alignItems: 'center' }}>
        {findedItem?.id === item?.id ? (
          <IconButton color="primary">
            <Icon icon="eva:checkmark-circle-2-fill" />
          </IconButton>
        ) : (
          <Button onClick={selectHandler}>Elegir</Button>
        )}
        <MenuCardButton itemId={dataItem.id} functionList={functionList} />
      </Box>
    </CuztomCard>
  );
}

export default CardItem;
